import { render, staticRenderFns } from "./InstagramPhotosSlider.vue?vue&type=template&id=34fbb526&scoped=true&"
import script from "./InstagramPhotosSlider.vue?vue&type=script&lang=js&"
export * from "./InstagramPhotosSlider.vue?vue&type=script&lang=js&"
import style0 from "./InstagramPhotosSlider.vue?vue&type=style&index=0&id=34fbb526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fbb526",
  null
  
)

export default component.exports